import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBin5Line, RiGalleryUploadLine } from 'react-icons/ri';


interface slider {
  title: string;
  content: string;
  id: number;
  image: string;
  is_active?: number;
}
const HomeBanner = () => {
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [sliderdata, setSliderdata] = useState<slider[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };

  const toggleStatus = async (id: number, currentStatus?: number) => {
    const newStatus = currentStatus === 0 ? 1 : 0;
    try {
      await axios.put(`https://rmbbackend.rmbjaipur.com/auth/banner/toggle-status/${id}`, { is_active: newStatus });
      setSliderdata(prev => prev.map(item => item.id === id ? { ...item, is_active: newStatus } : item));
      alert(`Banner status updated to ${newStatus === 1 ? 'ACTIVE (Live on Homepage)' : 'INACTIVE (Hidden from Homepage)'}`);
    } catch (error) {
      console.error('Error toggling status:', error);
      alert('Failed to update status.');
    }
  };

  const deletePost = async (id: any) => {
    if (!id) {
      alert('Invalid ID. Cannot delete.');
      return;
    }
    const confirmation = window.confirm('Are you sure you want to delete this slide?');
    if (!confirmation) {
      return;
    }

    try {
      await axios.delete(`https://rmbbackend.rmbjaipur.com/auth/homebanner/${id}`);
      alert('Post deleted successfully!');
      setSliderdata(prev => prev.filter(item => item.id !== id));
    } catch (error) {
      console.error('Error deleting post:', error);
      alert('Failed to delete the post. Please try again later.');
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<slider[]>(
          "https://rmbbackend.rmbjaipur.com/auth/homeslider?all=true"
        );
        setSliderdata(response.data || []);
      } catch (error) {
        console.error("slider Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className='p-4'>
      <div className='w-full'>

        <div className='flex justify-center w-[130px] cursor-pointer h-[45px] px-2 py-2 bg-[#FDBC12] text-darkblue items-center rounded-lg gap-2 font-bold' onClick={() => openModal('')}>
          <BsPlusCircleFill />  <h6>Add New Banner</h6>
        </div>

        <div>
          {sliderdata.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pt-4">
              {sliderdata.map((item) => (

                <div key={item.id} className='bg-slate-900 border border-slate-700 text-slate-100 rounded-xl p-3 shadow-lg flex flex-col justify-between space-y-3 relative'>
                  <div className="relative">
                    <img
                      className="h-40 object-cover w-full rounded-lg bg-slate-950"
                      src={
                        item.image
                          ? item.image.startsWith("http")
                            ? item.image
                            : `https://rmbbackend.rmbjaipur.com/${item.image.replace(/^\//, '')}`
                          : "https://via.placeholder.com/150"
                      }
                      alt={item.title || "Image"}
                    />

                    {/* Status Badge Indicator */}
                    <div className={`absolute top-2 left-2 px-2.5 py-1 rounded-full text-[10px] font-black uppercase shadow-lg border ${item.is_active === 0 ? 'bg-red-950 text-red-300 border-red-500/60' : 'bg-emerald-950 text-emerald-300 border-emerald-500/60'
                      }`}>
                      {item.is_active === 0 ? '🔴 INACTIVE (Hidden)' : '🟢 ACTIVE (Live)'}
                    </div>
                  </div>

                  <div>
                    <h3 className='font-bold text-base text-white line-clamp-1'>{item.title}</h3>
                    <p className="text-slate-400 text-xs mt-1 line-clamp-2">
                      {item.content}
                    </p>
                  </div>

                  {/* Status Toggle & Action Controls */}
                  <div className="space-y-2 pt-2 border-t border-slate-800">
                    <button
                      onClick={() => toggleStatus(item.id, item.is_active)}
                      className={`w-full py-2 rounded-lg text-xs font-bold transition flex items-center justify-center gap-1.5 cursor-pointer border ${item.is_active === 0
                          ? 'bg-emerald-600/20 hover:bg-emerald-600 text-emerald-300 border-emerald-500/40 hover:text-white'
                          : 'bg-red-600/20 hover:bg-red-600 text-red-300 border-red-500/40 hover:text-white'
                        }`}
                    >
                      {item.is_active === 0 ? '🟢 Set Active (Show on Homepage)' : '🔴 Set Inactive (Hide from Homepage)'}
                    </button>

                    <div className='flex items-center justify-between gap-2'>
                      <button className='flex-1 py-1.5 border border-blue-500/60 hover:bg-blue-600 text-blue-300 hover:text-white font-bold text-xs justify-center items-center rounded-lg gap-1 flex cursor-pointer' onClick={() => openModal(item.id + "")}>
                        <CiEdit size={14} /> Edit
                      </button>

                      <button className='flex-1 py-1.5 border border-red-500/60 hover:bg-red-600 text-red-300 hover:text-white font-bold text-xs justify-center items-center rounded-lg gap-1 flex cursor-pointer' onClick={() => deletePost(item.id)}>
                        <RiDeleteBin5Line size={14} /> Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-slate-400 font-bold p-4">No banners created yet.</p>
          )}
        </div>
      </div>


      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
    </div>
  )
}


interface ModalProps {
  postId?: string | null;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {


  const [formData, setFormData] = useState({
    title: '',
    content: '',
    image: null as File | null,

  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/homebanner/${postId}`);


          const data = Array.isArray(response.data) ? response.data[0] : response.data;
          // Access the first element

          // Destructure from the first element of the array
          const { title, content, image: image } = data;


          console.log("Title:", title);
          console.log("Content:", content);
          console.log("Image:", image);
          setFormData({
            title,
            content,
            image: image || null,

          });

          setFileName(image);
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.title || !formData.content) {
      setError('All fields are required.');
      return;
    }



    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    if (formData.image) { data.append('image', formData.image); }

    else if (fileName) {

      data.append('image', fileName);
    }



    console.log('Data data ' + formData.image);
    console.log('filename ' + fileName);

    console.log('Submitting form data:', {
      title: formData.title,
      content: formData.content,
      image: formData.image,
    });

    try {
      if (postId) {
        await axios.put(`https://rmbbackend.rmbjaipur.com/auth/homebanner/${postId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        console.log('slider updated successfully');
      } else {
        await axios.post('https://rmbbackend.rmbjaipur.com/auth/homebanner', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        console.log('slider created successfully');
      }
      onClose();
      window.location.href = '/dashboard';
    } catch (err) {
      console.error('Error submitting post:', err);
      setError('Failed to submit the post. Please try again.');
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-1/2 p-6 rounded shadow relative">

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="text-[#030303] font-medium"> Post title</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Write your post title here..."
                className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
                required
              />
            </div>
          </div>


          {/* Content */}
          <div>
            <label className="text-[#030303] font-medium">Description</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleChange}
              className="mt-1 mb-4 p-2 block w-full h-[150px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              placeholder="Write your message here..."
              rows={4}
              required
            />
          </div>


          {/* File Upload */}
          <div>
            <label className="text-[#030303]  font-medium">  Add media</label>
            <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">

              <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
                onClick={() => document.getElementById('file-upload')?.click()} />
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name='image'

                onChange={handleFileChange}


              />
              {fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Drag and Drop or{' '}
                  <span className="text-[#02256d]">click to upload</span>
                </p>
              )}
            </div>

          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}


          <div className=' flex justify-between'>

            {/*Cancel form button*/}
            <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold' onClick={onClose}>Cancel</button>
            {/* Submit Button */}
            <button
              type="submit"
              className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
              disabled={!formData.title || !formData.content}
            >
              {postId ? 'Update Slider' : 'Create Slider'}
            </button>
          </div>






        </form>
      </div>
    </div>
  );
};
export default HomeBanner